import { useAuth0 } from "@auth0/auth0-react";
import { useState } from "react";
import { getResourceDependencies } from "api/ResourceDependenciesApi";

const useScheduleInUse = () => {
  const { user } = useAuth0();
  const [useInFlows, setUseInFlows] = useState([]);
  const [isCheckFailed, setIsCheckFailed] = useState(false);

  const isScheduleInUse = async (scheduleId, flows = []) => {
    try {
      setIsCheckFailed(false);

      const response = await getResourceDependencies({
        tenantId: user?.stripeId,
        sourceId: scheduleId,
        direction: "forward",
        targetResourceType: "flow"
      });

      if (!response?.isSuccessful) {
        throw new Error(response?.message || "Failed to retrieve schedule usage");
      }

      const flowIdsUsingSchedule = [
        ...new Set(
          (response.resultObject || []).map((dependency) => dependency.target_id)
        )
      ];

      const validFlowsUsingSchedule = flowIdsUsingSchedule
        .map((flowId) => flows.find((flow) => flow.id === flowId))
        .filter(Boolean);

      setUseInFlows(validFlowsUsingSchedule);

      return validFlowsUsingSchedule.length > 0;
    } catch {
      setUseInFlows([]);
      setIsCheckFailed(true);
      return true;
    }
  };

  return {
    isScheduleInUse,
    useInFlows,
    isCheckFailed
  };
};

export default useScheduleInUse;
